import '../CreateEditDialog.scss';

import { Button } from 'primereact/button';
import { InputMask } from 'primereact/inputmask';
import { Fragment, useMemo } from 'react';
import { Controller, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormDataHub } from '../../../../../../../types/api/hubs';
import FieldWithErrors from '../../../../../../Forms/ReactHookForm/FieldWithErrors';
import { getDays } from '../CreateEditDialog.functions';

function ReconciliationIntervals() {
  const { t } = useTranslation();
  const days = useMemo(() => getDays(t), [t]);

  const { fields, append, remove } = useFieldArray<
    FormDataHub,
    'reconciliationTimeInterval'
  >({
    name: 'reconciliationTimeInterval',
  });

  const addDay = (dayOfWeek: number) => {
    if (!fields.some((f) => f.dayOfWeek === dayOfWeek)) {
      append({
        dayOfWeek,
        timeSpanFrom: '00:00',
        timeSpanTo: '00:00',
      });
    }
  };

  const availableDays = useMemo(
    () => days.filter((d) => !fields.some((f) => f.dayOfWeek === d.dayOfWeek)),
    [days, fields]
  );

  return (
    <div className="intervals">
      {fields?.map((iv, idx) => (
        <Fragment key={iv.dayOfWeek}>
          <div key={iv.dayOfWeek} className="time-row">
            <label className="time-label">
              {days.find((d) => d.dayOfWeek === iv.dayOfWeek)?.label || ''}
            </label>

            <FieldWithErrors
              name={`reconciliationTimeInterval.${idx}.timeSpanFrom`}
              label={false}
            >
              <Controller
                name={`reconciliationTimeInterval.${idx}.timeSpanFrom`}
                render={({ field }) => (
                  <InputMask
                    {...field}
                    id={`reconciliationTimeInterval[${idx}].timeSpanFrom`}
                    name={`reconciliationTimeInterval.${idx}.timeSpanFrom`}
                    mask="99:99"
                    placeholder="HH:MM"
                    className="time-input"
                  />
                )}
              />
            </FieldWithErrors>

            <FieldWithErrors
              name={`reconciliationTimeInterval.${idx}.timeSpanTo`}
              label={false}
            >
              <Controller
                name={`reconciliationTimeInterval.${idx}.timeSpanTo`}
                render={({ field }) => (
                  <InputMask
                    {...field}
                    id={`reconciliationTimeInterval[${idx}].timeSpanTo`}
                    name={`reconciliationTimeInterval.${idx}.timeSpanTo`}
                    mask="99:99"
                    placeholder="HH:MM"
                    className="time-input"
                  />
                )}
              />
            </FieldWithErrors>

            {(idx === 5 || idx === 6) && (
              <Button
                type="button"
                label="×"
                className="remove-interval-btn p-button-danger"
                onClick={() => remove(idx)}
              />
            )}
          </div>
        </Fragment>
      ))}

      <div className="add-days">
        {availableDays.length > 0 && (
          <div className="add-days">
            <div className="day-buttons">
              {availableDays.map((d) => (
                <Button
                  key={d.dayOfWeek}
                  type="button"
                  label={d.label}
                  onClick={() => addDay(d.dayOfWeek)}
                  className="p-button-sm p-button-text"
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ReconciliationIntervals;
